import axios from "../../../context/axiosConfig";

const pozyczkiAddComment = async ({ loanId, comment, user }) => {
	return axios.post("/pozyczki/comment/add", {
		loanId,
		comment,
		user,
	});
};

export default pozyczkiAddComment;
